module.exports = __webpack_public_path__ + "media/components/country-flag/static/ki-b33bc5bce1f91f864100549e01161f9b.svg";